import { Link } from "react-router-dom";
import { useLang } from "../i18n/LanguageContext";

export default function NotFound() {
  const { t } = useLang();
  return (
    <div className="container-page py-32 text-center" data-testid="not-found-page">
      <div className="overline">404</div>
      <h1 className="display-heading text-6xl mt-6">—</h1>
      <p className="mt-6 text-[hsl(var(--muted-foreground))]">Página não encontrada.</p>
      <Link to="/" className="btn-outline mt-10 inline-flex">{t.common.backHome}</Link>
    </div>
  );
}
